import { render, staticRenderFns } from "./TheBurgerMenu.vue?vue&type=template&id=4a0aa9a9&scoped=true&"
import script from "./TheBurgerMenu.vue?vue&type=script&lang=js&"
export * from "./TheBurgerMenu.vue?vue&type=script&lang=js&"
import style0 from "./TheBurgerMenu.vue?vue&type=style&index=0&id=4a0aa9a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0aa9a9",
  null
  
)

export default component.exports